import { Row } from "antd";
import moment from "moment";
import React from "react";
import { getFileIcon } from "../../../../../../components/fileinformation";
import "./styles.css";
import { getImage } from "./../../../../../../utilities/storageOperations/downloadURL";
import FileDownloader from "./FileDownloader/FileDownloader";

let userProfile = JSON.parse(localStorage.getItem("userProfile"));
const profession = userProfile?.Professions?.ProfessionCode

const budgetOptions = [
  {
    BudgetTypeId: 3,
    BudgetTypeName: "Month",
    BudgetType: "mn",
  },
  {
    BudgetTypeId: 1,
    BudgetTypeName: "Hour",
    BudgetType: "hr",
  },
  {
    BudgetTypeId: 5,
    BudgetTypeName: "Daily",
    BudgetType: "daily",
  },
  {
    BudgetTypeId: 2,
    BudgetTypeName: "Week",
    BudgetType: "wk",
  },
  {
    BudgetTypeId: 4,
    BudgetTypeName: "Year",
    BudgetType: "yr",
  },
];

export const OfferCards = ({ status, OfferCards, items }) => {
  // let links = OfferCards.map((e) => getImage(e.FileName));
  return (
    <>
      {status == "Offer Pending" ? (
        <>
          <div>
            {/* Congratulations!  */}
            <p>Congrats! You’ve sent the candidate an offer.</p>
          </div>
          <div className="offer-card-offer-div">
            <Row className="offer-card-details">
              <strong>Start date</strong>
              <div>{moment(OfferCards?.FromDate).format("MMMM DD, YYYY")}</div>
            </Row>
            {/* <Row className="offer-card-details">
              <strong>Bid rate</strong>
              <div>{`${OfferCards?.Currency} ${OfferCards?.Rate}/${OfferCards?.BudgetType}`}</div>
            </Row> */}
            {profession=="HC" &&
               (OfferCards?.BudgetType?
                  (
                    <Row className="offer-card-details">
                  <strong>Bid rate</strong>
                  <div style={{ display: 'flex', maxWidth: '58%' }}>
                    {/* <span className="offerCardRate-sides">{`${OfferCards?.Currency} `}{'\u00A0'} </span> */}
                    <span>{`${OfferCards?.Currency} `}{'\u00A0'} </span>
                    {/* <span className="offerCardRate">${items?.BidCard?.ActualRate}</span>
                    <span className="offerCardRate-sides">/{items?.BidCard?.BudgetTypeId
                      ? budgetOptions?.find((o) => {
                        return o.BudgetTypeId === items?.BidCard?.BudgetTypeId;
                      }).BudgetType
                      : null}</span> */}
                  {/* <span className="offerCardRate">{OfferCards?.Rate}</span>
                  <span className="offerCardRate">{OfferCards?.BudgetType =='Weekly'? '/wk':OfferCards?.BudgetType =='Hourly'?'/hr':'/hr'}</span> */}
                  <span >{OfferCards?.Rate}</span>
                  <span >{OfferCards?.BudgetType =='Hourly'? '/hr':OfferCards?.BudgetType =='Weekly' &&'/wk'}</span>
                  </div>
                </Row>
                    )
                  :
                  null
                )
              
            }
            <Row className="offer-card-details">
              <strong>End date</strong>
              <div>{moment(OfferCards?.ToDate).format("MMMM DD, YYYY")}</div>
            </Row>
            {(OfferCards?.Message != "" && OfferCards?.Message != null && OfferCards?.Message != undefined && OfferCards?.Message !="<p><br></p>")  &&
              <div style={{ marginTop: "2.5%" }}>
                {<strong>Offer message</strong>}
                <p style={{ color: "#7e7e7e" }}>
                  <div
                    dangerouslySetInnerHTML={{ __html: OfferCards?.Message }}
                  ></div>
                </p>
              </div>}
          </div>
          {OfferCards?.Attachments?.length>0&&<div
            style={{ margin: "2.5% 0%", color: "#4e4e4e", fontSize: "14px" }}
          >
            Open the document to digitally sign the offer:
          </div>}
          {OfferCards?.Attachments?.map((res) => {
            return (
              <Row key={res.FileName} className="offer-card-attachmentdiv">
                <FileDownloader {...res} />
              </Row>
            );
          })}
        </>
      ) : status == "Hired" ? (
        <div>
          {/* <strong>Congratulations!</strong> */}
          <p>Congrats!You’ve successfully hired a new employee.</p>
        </div>
      ) : (
        status == "Offer Accepted" && (
          <>
            <div>
              {/* <strong>Congratulations!</strong> */}
              <div>Congrats! The candidate accepted your offer on:</div>
            </div>
            <div className="offer-card-offer-div" style={{ marginTop: "3%" }}>
              {/* <div class  Name="date"> */}
                {moment(OfferCards?.Created).format("dddd, MMMM DD, YYYY")}
                
              {/* </div> */}
            </div>
            {
              OfferCards?.CandidateAttachments[0] != false && 
              <div className="candidateAttachment">
                <div>Here’s a copy of your signed offer document:</div>
            {OfferCards?.CandidateAttachments?.map((res) => {
              return (
                <Row
                  key={res?.FileName ?? res?.fileName}
                  className="offer-card-attachmentdiv"
                >
                  <FileDownloader {...res} />
                </Row>
              );
            })} 
            </div>
            }
         <div>
         Review your candidates credentials and other materials to complete your hiring process. Or move your candidate’s status to “hired”. 
         </div>
         {/* <div className="time">
                {moment(OfferCards?.Created).format("h:mm A")}
              </div> */}

            {/* <div style={{ backgroundColor: '#fff', padding: '3% 4%', marginTop: '3%', borderRadius: '4px' }}>
                            <strong>{moment(items.Created).format('MMMM DD, dddd, YYYY')}</strong> <br />
                            {moment(props.InterviewCard?.ApprovedScheduledTiming.StartTime).format('h:mm A')} - {moment(props.InterviewCard.ApprovedScheduledTiming.EndTime).format('h:mm A')}
                        </div> */}
          </>
        )
      )}
    </>
  );
};
